import { Controller } from '@hotwired/stimulus';

// Prevents dropdown menus in responsive tables from causing
// unwanted scroll by repositioning them to the body.
//
// Usage:
//   <div class="table-responsive"
//        data-controller="table-dropdown"
//        data-action="show.bs.dropdown->table-dropdown#showDropdown
//                     hide.bs.dropdown->table-dropdown#hideDropdown">
//     ...
//   </div>
export default class TableDropdownController extends Controller {
  showDropdown(event) {
    const toggle = event.relatedTarget;
    const rect = toggle.getBoundingClientRect();
    const menu = toggle.nextElementSibling;

    if (!menu) return;

    this.activeMenu = menu;
    menu.classList.add('dropdown-menu-in-table');
    document.body.appendChild(menu);
    menu.style.display = 'block';
    menu.style.top = `${rect.bottom + window.scrollY}px`;
    menu.style.left = `${rect.left + window.scrollX}px`;
  }

  hideDropdown(event) {
    const menu = this.activeMenu;
    if (!menu) return;

    menu.classList.remove('dropdown-menu-in-table');
    menu.style.display = '';
    menu.style.top = '';
    menu.style.left = '';
    event.relatedTarget?.parentElement?.appendChild(menu);
    this.activeMenu = null;
  }
}
